import { render, staticRenderFns } from "./BaseCollapsible.vue?vue&type=template&id=0e9cb599&scoped=true&"
import script from "./BaseCollapsible.vue?vue&type=script&lang=js&"
export * from "./BaseCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./BaseCollapsible.vue?vue&type=style&index=0&id=0e9cb599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9cb599",
  null
  
)

export default component.exports